module.exports = __webpack_public_path__ + "static/mobile_spectrum_loop-8fe2294d66bfcb527c90fc21e9542053.png";